import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funfact',
  templateUrl: './funfact.component.html',
  styleUrls: ['./funfact.component.scss']
})
export class FunfactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
